import React, { useEffect, useRef, useState, useContext } from "react";
import SecondaryHeader from "../SecondaryHeader/SecondaryHeader";
import MenuBar from "../MenuBar/MenuBar";
import user from "../../assets/1.jpg";
import { HttpGet, HttpPost } from "../../providers/HttpClient";
import LoadingOverlay from "react-loading-overlay-ts";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Alert from "../alertComponent/alertComponent";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const OvertimeList: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [datas, setDatas] = useState<any>([]);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const [startDate, setStartDate] = useState(
    new Date(currentYear, currentMonth, 1)
  );
  const [endDate, setEndDate] = useState(
    new Date(currentYear, currentMonth, 1)
  );
  const [expanded, setExpanded] = useState(false);

  const getOvertimeList = async (startDate, endDate) => {
    let startExtensionDate = moment(startDate).format("YYYY-MM-DD");
    let endExtensionDate =
      // startDate.getMonth() === endDate.getMonth()
      // ?
      moment(endDate).add(29, "days").format("YYYY-MM-DD");
    // : moment(endDate).format("YYYY-MM-DD");
    setLoading(true);

    HttpGet(
      `member/work_extension?startExtensionDate=${startExtensionDate}&endExtensionDate=${endExtensionDate}&sort=extensionDate&dir=-1`
    )
      .then((res: any) => {
        setDatas(res.data.content);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChange = ([newStartDate, newEndDate]) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  useEffect(() => {
    if (startDate && endDate) {
      getOvertimeList(startDate, endDate);
    }
  }, [startDate, endDate]);

  return (
    <>
      <div className="bg-main h-full">
        <div className="z-100 z-30 mb-4 pb-24 px-1">
          <p className="fixed top-0 left-0 w-full bg-white py-4 text-center font-header font-bold shadow z-50">
            Lembur
          </p>

          <div className="pt-16">
            <div className="flex justify-center mb-4 mt-4">
              <DatePicker
                className="border-2 rounded-md text-center"
                startDate={startDate}
                endDate={endDate}
                onChange={handleChange}
                dateFormat="MM/yyyy"
                placeholderText="Pilih Tanggal"
                showMonthYearPicker
                withPortal
                selectsRange
                // showIcon
                // icon="calendar"
              />
            </div>
            {datas.length
              ? datas.map((prop: any, index: any) => {
                  return (
                    <div className="rounded-2xl w-full bg-gray-50 p-3 shadow-md mb-4">
                      <div>
                        <div className="flex items-center justify-between">
                          <p className="font-normal text-sm mb-1">
                            Request Lembur
                          </p>
                          <span
                            className={`inline-flex items-center gap-1 rounded-full ${
                              prop.status === "ACCEPTED"
                                ? "bg-green-500"
                                : prop.status === "PENDING"
                                ? "bg-orange-500"
                                : "bg-red-500"
                            } px-2.5 py-0.5 text-xs font-medium text-white`}
                          >
                            {prop.status === "ACCEPTED"
                              ? "Diterima"
                              : prop.status === "PENDING"
                              ? "Menunggu"
                              : "Ditolak"}
                          </span>
                        </div>
                        <hr className="mt-2" />
                        <div className="flex items-center justify-between mt-2">
                          <p className="font-normal text-xs text-slate-500">
                            Tgl Pengajuan
                          </p>
                          <p className="font-normal text-xs text-slate-500">
                            {moment(prop.extensionDate).format("DD MMMM YYYY")}
                          </p>
                        </div>
                        <div className="flex items-center justify-between mt-2">
                          <p className="font-normal text-xs text-slate-500">
                            Keterangan
                          </p>
                          <div className="text-right max-w-[200px]">
                            <p className="font-normal text-xs text-slate-500 break-words text-justify">
                              {expanded
                                ? prop.note
                                : prop.note.length > 20
                                ? prop.note.slice(0, 20) + "..."
                                : prop.note}
                            </p>
                            {prop.note.length > 20 && (
                              <button
                                onClick={() => setExpanded(!expanded)}
                                className="text-[11px] text-blue-600 hover:underline"
                              >
                                {expanded
                                  ? "Lihat lebih sedikit"
                                  : "Lihat lebih"}
                              </button>
                            )}
                          </div>
                        </div>

                        {prop.status === "ACCEPTED" && (
                          <>
                            <p className="mt-2 font-normal text-xs text-slate-900">
                              Disetujui Oleh : Admin
                            </p>
                            <p className="font-normal text-xs text-slate-900">
                              Catatan : {prop.noteApproval}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
            <div className="bar fixed z-50 bottom-0 w-full bg-white px-4 py-5">
              <button
                className={
                  "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-300 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
                }
                onClick={() => {
                  navigate(`/home/overtimes-form`);
                }}
              >
                {"Ajukan Lembur"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OvertimeList;
